import fileDownload from "js-file-download";
import * as moment from "moment";
import {
    GESTIONAR_EMPRESAS_TRASLADO,
    CONSULTAR_EMPRESAS_TRASLADO,
    DESCARGAR_XLS_EMPRESAS_TRASLADO,
    EXITO_DESCARGAR_EMPRESAS_TRASLADO_XLS,
    ERROR_DESCARGAR_EMPRESAS_TRASLADO_XLS,
    GESTION_EMPRESAS_TRASLADO_ERROR,
    GESTION_EMPRESAS_TRASLADO_EXITO,
    EMPRESAS_TRASLADO_CONSULTADOS,
    ERROR_CONSULTANDO_EMPRESAS_TRASLADO,
    empresasTrasladoConsultados,
    errorConsultandoEmpresasTraslado,
    exitoDescargarEmpresasTrasladoXLS,
    errorDescargarEmpresasTrasladoXLS,
    gestionEmpresasTrasladoError,
    gestionEmpresasTrasladoExito
} from "./gestionEmpresaTrasladoActions";
import { AnyAction } from "redux";
import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { errorAutorizacion } from "../../../../inicio/modulos/inicioActions";
import { FiltroEmpresasTraslado, GestionTraslado, RespuestaEmpresasTraslado } from "../modelo/GestionEmpresasModelo";
import {
    cabeceraReporteTrasladoEmpresas,
    LibroDocumentoXLS
} from "../../../general/modelo/PlanillasXLS";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";

export const gestionarEmpresasTrasladoEpic = action$ =>
    action$.ofType(GESTIONAR_EMPRESAS_TRASLADO)
        .mergeMap((action: any) => {

            const url = `sat/gestionar/mensaje-empresa-traslado`;

            return authenticatedAjax
                .post(
                    url,
                    action.solicitud,
                    { 'Content-Type': 'application/json' }
                )
                .map((response) => {
                    return gestionEmpresasTrasladoExito();
                }).catch(response => {
                    const respuesta = response.response;
                    const mensajeRespuesta = (respuesta && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                    return [gestionEmpresasTrasladoError(mensajeRespuesta)];
                });
        });

export const consultarEmpresasTrasladoEpic = action$ =>
    action$.ofType(CONSULTAR_EMPRESAS_TRASLADO)
        .mergeMap((action: any) => {

            const url = `sat/consultar/mensaje-empresa-traslado?${obtenerFiltroConsulta(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return empresasTrasladoConsultados(respuesta.datosEntidad, respuesta.paginas, respuesta.totalDatos);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoEmpresasTraslado()];
                });
        });

export const descargarXLSEmpresasTrasladoEpic = action$ =>
    action$.ofType(DESCARGAR_XLS_EMPRESAS_TRASLADO)
        .mergeMap((action: any) => {

            const url = `sat/consultar/mensaje-empresa-traslado?${obtenerFiltroConsulta(action.filtro)}`;

            return authenticatedAjax
                .get(url)
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    if (respuesta && respuesta.datosEntidad) {
                        const excelBlob: Blob = construirXLS(respuesta.datosEntidad);
                        const nombreArchivo = `reporte_empresas_traslado_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
                        fileDownload(
                            excelBlob,
                            nombreArchivo,
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        );
                        return exitoDescargarEmpresasTrasladoXLS();
                    }
                    return errorDescargarEmpresasTrasladoXLS();
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [];
                });
        });

export const empresasTrasladoReducer = (state = {
    estado: REQUEST.NONE,
    estadoDescarga: REQUEST.NONE,
    datosRespuesta: [],
    paginas: 0,
    totalDatosConsulta: 0,
    tamanoPagina: 10,
    paginaActual: 0
}, action: AnyAction) => {
    switch (action.type) {

        case GESTIONAR_EMPRESAS_TRASLADO:
            return {
                ...state,
                estado: REQUEST.PENDING,
                servicios: registroEnGestion(action.solicitud, state.datosRespuesta),
                showAlert: false
            };
        case GESTION_EMPRESAS_TRASLADO_EXITO:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                estadoAccion: REQUEST.SUCCESS,
                showAlert: true
            };
        case GESTION_EMPRESAS_TRASLADO_ERROR:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                estadoAccion: REQUEST.ERROR,
                mensajeAccion: action.mensaje,
                showAlert: true
            };
        case CONSULTAR_EMPRESAS_TRASLADO:
            return {
                ...state,
                estado: REQUEST.PENDING,
                datosRespuesta: [],
                paginas: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                totalDatosConsulta: 0,
                paginaActual: action.filtro.paginaActual,
                showAlert: false
            };
        case DESCARGAR_XLS_EMPRESAS_TRASLADO:
            return {
                ...state,
                estadoDescarga: REQUEST.PENDING
            };
        case EXITO_DESCARGAR_EMPRESAS_TRASLADO_XLS:
        case ERROR_DESCARGAR_EMPRESAS_TRASLADO_XLS:
            return {
                ...state,
                estadoDescarga: REQUEST.SUCCESS
            };
        case EMPRESAS_TRASLADO_CONSULTADOS:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                datosRespuesta: action.datosRespuesta,
                paginas: action.paginas,
                totalDatosConsulta: action.totalDatos,
                showAlert: false
            };
        case ERROR_CONSULTANDO_EMPRESAS_TRASLADO:
            return {
                ...state,
                estado: REQUEST.ERROR,
                datosRespuesta: [],
                paginas: 0,
                totalDatosConsulta: 0,
                showAlert: false
            };
        default:
            return state;
    }
};



const obtenerFiltroConsulta = (filtro: FiltroEmpresasTraslado) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.dniEmpleador) params.set('dniEmpleador', filtro.dniEmpleador);
        if (filtro.fechaInicial) params.set('fechaInicial', filtro.fechaInicial);
        if (filtro.fechaFinal) params.set('fechaFinal', filtro.fechaFinal);
        if (Number.isInteger(filtro.causal)) params.set('causal', filtro.causal.toString());
        if (Number.isInteger(filtro.excepcionado)) params.set('excepcionado', filtro.excepcionado.toString());
        if (Number.isInteger(filtro.estado)) params.set('estado', filtro.estado.toString());
        if (filtro.canalIngreso) params.set('canalIngreso', filtro.canalIngreso);
        if (filtro.dniProceso) params.set('dniProceso', filtro.dniProceso);
        if (Number.isInteger(filtro.paginaActual)) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');

    }

    return params.toString();
};

const registroEnGestion = (solicitud: GestionTraslado, registros: Array<RespuestaEmpresasTraslado>) => {
    return registros.map(registro => {
        solicitud.consecutivos.map(consecutivo => {
            if (registro.consecutivo === consecutivo) {
                registro.pendiente = true;
            }
        });
    });
};

const construirXLS = (datos: Array<RespuestaEmpresasTraslado>) => {
    /*Libros a generar en el XLS*/
    const libroDatos = 'Reporte Empresas Traslado';

    const librosXLS = [];
    librosXLS.push(libroDatos);

    const reporte = [];

    const stringVacio = (texto: string) => {
        return texto ? texto : "";
    };

    const causalVacio = (numero: any) => {
        return Number.isInteger(numero) ? numero : "";
    };

    datos.forEach(dato => {
        reporte.push([
            { value: dato.consecutivo },
            { value: dato.dniEmpleador },
            { value: dato.esComercial },
            { value: stringVacio(dato.mensajeEnvioSAT) },
            { value: stringVacio(dato.mensajeRespuestaSAT) },
            { value: stringVacio(dato.mensajeEnvioMoraSAT) },
            { value: stringVacio(dato.mensajeRespuestaMoraSAT) },
            { value: stringVacio(dato.empresTrasladable) },
            { value: causalVacio(dato.causal) },
            { value: stringVacio(dato.tipoExcepcion) },
            { value: stringVacio(dato.arlAfiliacion) },
            { value: stringVacio(dato.respuestaSURA) },
            { value: stringVacio(dato.estado) },
            { value: stringVacio(dato.fechaProceso) },
            { value: stringVacio(dato.observacion) },
            { value: stringVacio(dato.dniProceso) },
        ]);
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libroDatos,
        cabecera: cabeceraReporteTrasladoEmpresas(),
        datos: reporte,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/gestion_empresas_trasladables/modulos/gestionEmpresaTrasladoReducers.ts